import React from "react";
import {useRouteLoaderData} from "react-router-dom";
import translate from "../../../../translate";
import {ButtonTypes, LinkButton} from "../../ui/spectre/buttons";
import CopyableInviteLink from "./copyableInviteLink";

export default function GroupCreated() {
    /**
     * @type {{ invites: array, id: int }}
     */
    const groupData = useRouteLoaderData('group');

    if(groupData.invites === null) {
        return <div className={'bg-error p-2'}>{translate('error/groups/no_access')}</div>
    }

    const invite = Object.values(groupData.invites)[0];

    return <div>
        <div className={'bg-success p-2'}>{translate('page/group/created/success_message')}</div>

        <div className={'mt-2'}>
            <div>{translate('page/group/created/invite_header_text')}</div>
            <div>
                <CopyableInviteLink link={invite.link}/>
            </div>
        </div>

        <div className={'mt-2'}>
            <LinkButton href={'/group/' + groupData.id} buttonTypes={[ButtonTypes.primary]}>
                {translate('page/group/created/go_to_group')}
            </LinkButton>
        </div>
    </div>
}
